import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Gallery from "@/components/Gallery";
import Amenities from "@/components/Amenities";
import Rates from "@/components/Rates";
import Location from "@/components/Location";
import Aurora from "@/components/Aurora";
import SummerScene from "@/components/SummerScene";
import EnquiryForm from "@/components/EnquiryForm";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div
      className="bg-[#F7F4EF] font-sans text-[#1A1C19] antialiased"
      data-testid="app-root"
    >
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Gallery />
        <Amenities />
        <Rates />
        <Location />
        <Aurora />
        <SummerScene />
        <EnquiryForm />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}

export default App;
